import { useStorage } from '@vueuse/core'

const STORAGE_KEY = 'rockestate_advanced_mode'

export function useAdvancedMode() {
  const showAdvanced = useStorage<boolean>(STORAGE_KEY, false)

  const toggleAdvanced = () => {
    showAdvanced.value = !showAdvanced.value
  }

  return {
    showAdvanced,
    toggleAdvanced,
  }
}
